<template>
  <div class="product_footer" data-aos-delay="50">
    <img src="@/assets/product/产品底部.png" />
  </div>
</template>

<script>
import footer from "@/assets/product/产品底部.png";
export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="sass" scoped>
.product_footer {
  img {
    width: 100%;
    }
  }
</style>
